import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import ApiError from '../../../components/Errors/ApiError';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PracticalExerciseError = ({
  error
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    blockSize: "100%",
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(ApiError, {
      error: error
    })
  }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
    children: /*#__PURE__*/_jsx(Button, {
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.startExercise"
      })
    })
  })]
});
export default PracticalExerciseError;